import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { Icon, inkA, orange, PlainButton, tokens } from 'components/v3';
import { brand } from '../../shared/brand';
import BrandMark from '../fields/BrandMark';
import { Switch } from '../fields/ToggleRow';
import { ACCOUNT_INFO_ROWS } from '../state/accountInfo';

// "<Brand> account info" (design: AcctCard): the brand mark, a head that
// opens a stacked list of the five fields, and a switch that adds or
// removes them all.

const Head = styled(PlainButton)`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  border-radius: 8px;
`;

const AccountInfoCard = ({ on, onToggle, disabled }) => {
  const theme = useTheme();
  const t = tokens(theme);
  const [open, setOpen] = useState(false);
  const { name } = brand();
  const title = `${name} account info`;
  return (
    <div
      style={{
        borderRadius: 12,
        border: '1px solid ' + (on ? orange(1) : t.border),
        background: inkA(theme, 0.03),
        transition: 'border-color 150ms ease',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '10px 12px 10px 10px',
        }}
      >
        <Head aria-expanded={open} onClick={() => setOpen((v) => !v)}>
          <BrandMark size={24} radius={4} />
          <span
            style={{
              flex: 1,
              minWidth: 0,
              fontSize: 13,
              fontWeight: 700,
              color: t.text,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {title}
          </span>
          <span
            style={{
              display: 'flex',
              color: t.faint,
              transform: open ? 'rotate(180deg)' : 'none',
              transition: 'transform 150ms ease',
            }}
          >
            <Icon name="chevron-down" size={16} color="currentColor" />
          </span>
        </Head>
        <Switch on={on} label={title} disabled={disabled} onChange={onToggle} />
      </div>
      {open ? (
        <div
          style={{
            padding: '10px 12px 12px',
            borderTop: '1px solid ' + t.border,
          }}
        >
          <div style={{ fontSize: 11.5, color: t.faint, marginBottom: 6 }}>
            {`Auto-fills from the person’s ${name} account`}
          </div>
          {ACCOUNT_INFO_ROWS.map((row) => (
            <div
              key={row.label}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '7px 4px',
                fontSize: 13,
                fontWeight: 600,
                color: t.sub,
              }}
            >
              <Icon
                name={row.icon}
                size={15}
                color={on ? orange(1) : t.faint}
              />
              {row.label}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

AccountInfoCard.propTypes = {
  on: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

AccountInfoCard.defaultProps = { disabled: false };

export default AccountInfoCard;
